import React, { useState, useEffect } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
// import "primereact/resources/themes/tailwind-light/theme.css";
import "src/styles/theme.css";
// import "src/styles/style-light.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Toaster } from "react-hot-toast";
import Panel from "@components/Layout/Panel";
import Authentication from "@containers/Authentication";
import ErrorBoundary from "@containers/Error/ErrorBoundary";
import NotFound from "@containers/Error/NotFound";
import Forbidden from "@containers/Error/Forbidden";
import Callback from "@containers/Authentication/Callback";
import authenticationService from "@services/authentication.service";
// import * as Sentry from "@sentry/browser";

// Sentry.init({
//   dsn: "http://a2fec0d0810d40efaf3481ca028a4872@10.10.10.6:9000/5",
// });

function App() {
  const [error, setError] = useState(null);

  return (
    <>
      <Toaster />
      <ErrorBoundary
        resetErrorBoundary={() => {
          setError(null);
        }}
        onError={setError}
        error={error}
      >
        <Switch>
          <PrivateRoute path="/" exact component={Intro} />
          <PrivateRoute path="/dashboard" component={Panel} />
          <AuthRoute path="/auth" component={Authentication} />
          <Route path="/403" exact component={Forbidden} />
          <Route path="/callback/:to?" exact component={Callback} />
          <Route component={NotFound} />
        </Switch>
      </ErrorBoundary>
    </>
  );
}

export default App;

const Intro = () => {
  const history = useHistory();

  history.push("/dashboard/overview");

  return <></>;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [loading, setLoading] = useState(false);

  const clearDisconnect = () => {
    localStorage.removeItem("plano-disconnect");
  };

  if (
    !localStorage.getItem("plano-jwt")
    // !localStorage.getItem("plano-profile")
  ) {
    authenticationService.logout();
  }

  const testConnection = async () => {
    setLoading(true);
    try {
      const res = await authenticationService.isLogin();
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", clearDisconnect);

    testConnection();

    return () => {
      window.removeEventListener("beforeunload", clearDisconnect);
      // clearInterval(interval);
    };
  }, []);

  return (
    <Route
      {...rest}
      render={
        (props) => (loading ? <></> : <Component {...props} />)
        // ) : (
        // <Redirect
        //   to={{
        //     pathname: "/auth/login",
        //     state: { from: props.location },
        //   }}
        // />
        // )
      }
    />
  );
};

const AuthRoute = ({ component: Component, ...rest }) => {
  return <Route {...rest} render={(props) => <Component {...props} />} />;
};
